import reducer from "./reducer";
export { default as automaticProcessesReducerName } from "./constants";
export default reducer;
